import { gql, useMutation } from "@apollo/client";
import { Alert, Button, Card, Form, Layout, PageHeader, Space } from "antd";
import React, { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";

import { PriceListForm } from "./Form";

const createValuePriceListMutation = gql`
  mutation ($input: CreteValuePriceListInput!) {
    createValuePriceList(input: $input) {
      priceList {
        id
      }
    }
  }
`;

interface FieldData {
  name: string;
  errors: string[];
}

export const New: React.FC<{}> = () => {
  const [form] = Form.useForm();
  const [otherErrors, setOtherErrors] = useState<string[]>([]);
  const navigate = useNavigate();

  const [execMutation, { loading }] = useMutation(createValuePriceListMutation, {
    errorPolicy: "none",
    onError: ({ graphQLErrors }) => {
      const fieldsErrors: FieldData[] = [];
      const otherErrors: string[] = [];
      graphQLErrors?.forEach((graphQLError) => {
        if (graphQLError.name) {
          fieldsErrors.push({ name: graphQLError.name, errors: (graphQLError as any).messages });
        } else {
          otherErrors.push(graphQLError.message);
        }
      });
      form.setFields(fieldsErrors);
      setOtherErrors(otherErrors);
    },
    onCompleted: (data) => {
      navigate("..");
    },
  });

  const submit = (input: any) => {
    execMutation({ variables: { input } });
  };

  const data = {};

  return (
    <Fragment>
      <Layout className="content">
        <PageHeader
          ghost={true}
          title="New Price List"
          extra={
            <Space size="large">
              <Button onClick={() => navigate("..")}>Cancel</Button>
              <Button type="primary" loading={loading} onClick={() => form.submit()}>
                Save
              </Button>
            </Space>
          }
        />
        <Layout.Content className="content">
          <Card>
            {otherErrors.length > 0 && (
              <Space direction="vertical" style={{ marginBottom: "10px" }}>
                {otherErrors.map((otherError, index) => (
                  <Alert key={index} type="error" message="Error" description={otherError} />
                ))}
              </Space>
            )}
            <PriceListForm form={form} data={data} submit={submit} />
          </Card>
        </Layout.Content>
      </Layout>
    </Fragment>
  );
};
